import styled from 'styled-components';
import tw, { classnames, TTextColor, fontSize, padding, fontWeight } from 'tailwindcss-classnames';
import { textColor } from 'tailwindcss-classnames';

const getTextSize = (size: 'h1' | 'h2' | 'h3' | 'h4' | 'h5') => {
    return classnames(size === 'h1' ? fontSize('text-4xl') :        size === 'h2' ? fontSize('text-3xl') :        size === 'h3' ? fontSize('text-2xl') :        size === 'h4' ? fontSize('text-xl') : fontSize('text-lg'));
}

export const HeaderElement = (size: 'h1' | 'h2' | 'h3' | 'h4' | 'h5', color: TTextColor, colorDark: TTextColor) => {
    return (
        size === 'h1' ? styled.h1 :
        size === 'h2' ? styled.h2 :
        size === 'h3' ? styled.h3 :
        size === 'h4' ? styled.h4 :
                styled.h5).attrs({
                    className: classnames(getTextSize(size), textColor(color, colorDark), padding('pb-1'), fontWeight('font-extrabold'))
                })``;
}
